import RoutesMap from "../../route_control/RouteControl"
import {
    Profile,
    StaffList,
    AssignDepartmentList
} from "../../pages/user"

export const UsersImport = {
    RoutesMap,
    Profile,
    StaffList,
    AssignDepartmentList,
}